// Auto-generated translation for es.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:06:16.741271+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Para propietarios de caballos",
    title: "Todo para tu caballo. En una sola app.",
    subtitle: "Gestiona salud, entrenamiento, planificación y profesionales desde un único expediente claro y organizado.",
    primaryCTA: {
      label: "Empieza gratis",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Perfil del caballo — peso, vacunación, EquiCoach, alimentación y entrenamiento en una sola pantalla",
      caption: "Tu caballo, con una visión completa.",
    },
    problem: "Probablemente llevas citas, fotos, entrenamiento, alimentación y salud repartidos por distintos sitios — en grupos de WhatsApp, cajas de zapatos y apps separadas. Eso te hace perder el control.",
    solution: "EquiSight convierte a tu caballo en un expediente digital completo que te acompaña a todas partes.",
    benefits: [
      "Un perfil completo por caballo",
      "Salud, herrador, dentista y fisioterapeuta en un solo lugar",
      "Agenda con recordatorios inteligentes",
      "Fotos, notas e historial sin límite",
      "Copia de seguridad de todos tus datos con Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 caballo · siempre gratis",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Varios caballos + copia de seguridad",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "¿Listo para empezar?",
      title: "Comienza hoy con tu primer caballo.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Más caballos. Más control. Más seguridad.",
    subtitle: "Actualiza a Premium y gestiona todos tus caballos sin límites — con toda la inteligencia de EquiCoach.",
    primaryCTA: {
      label: "Empieza 14 días gratis",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver todos los precios",
      href: "/#pricing",
    },
    audience: "Para propietarios, jinetes deportivos y cuidadores con varios caballos.",
    features: [
      "Añade caballos sin límite",
      "Historial completo por caballo",
      "Copia de seguridad de datos",
      "Información avanzada de EquiCoach",
      "Notificaciones inteligentes y planificación",
      "Salud y entrenamiento totalmente integrados",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Menos de €0,17 al día",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "¿Listo?",
      title: "Actualiza a Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Para jinetes de picadero",
    title: "Mejora, aunque no tengas caballo propio.",
    subtitle: "Sigue tus clases, entrenamientos y desarrollo dentro de EquiSight — por menos de lo que cuesta un café al mes para papá o mamá. O un rico helado con nata.",
    primaryCTA: {
      label: "Empezar con Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "¿Cómo funciona?",
      href: "#features",
    },
    problem: "Como jinete de picadero, a menudo no tienes caballo propio, pero sí quieres crecer y tener una visión clara de tus clases, objetivos y los caballos en los que montas.",
    solution: "La funcionalidad de picadero está incluida de serie en Premium — sigue tu propio desarrollo y consulta los caballos del picadero vinculados en modo solo lectura.",
    features: [
      "Registrar entrenamientos",
      "Establecer objetivos",
      "Seguir el progreso",
      "Ver los caballos del picadero con nombre y foto",
      "Sin acceso a datos de salud privados",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Por mes · funcionalidad de picadero incluida",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Hazte miembro",
      title: "Empieza como jinete de picadero.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Para picaderos y establos",
    title: "Haz tu picadero digitalmente accesible para cada jinete.",
    subtitle: "Ofrece a los jinetes conexión con caballos, clases y progreso — sin compartir datos sensibles del establo.",
    primaryCTA: {
      label: "Solicitar acceso",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver módulos",
      href: "#features",
    },
    audience: "EquiSight ayuda a picaderos y establos a mantener a los jinetes más comprometidos y a destacarse digitalmente.",
    features: [
      "Hacer visibles los caballos del picadero para los jinetes",
      "Nombre y foto por caballo",
      "Vincular jinetes a caballos",
      "Acceso de solo lectura para datos sensibles de privacidad",
      "Historial de clases y entrenamiento centralizado",
      "Gestión de usuarios con roles",
    ],
    benefits: [
      "Mayor conexión con los jinetes",
      "Imagen más profesional",
      "Servicio digital adicional para los miembros",
      "Nueva fuente de ingresos a través del uso de la app",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Por mes · funcionalidad de picadero incluida para jinetes",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "¿Listo?",
      title: "Activa el Módulo de Picadero.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Módulo de cría",
    title: "Control total sobre el ciclo, la gestión y el desarrollo de potros.",
    subtitle: "El módulo de cría completo para propietarias de yeguas y criadores — desde la cubrición hasta el potro, en una sola línea de tiempo.",
    primaryCTA: {
      label: "Activar Módulo de Cría",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver funciones",
      href: "#features",
    },
    audience: "Para criadores, propietarias de yeguas y establos que gestionan varias yeguas.",
    features: [
      "Seguimiento del ciclo",
      "Registro de celos",
      "Registro de fechas de inseminación",
      "Cuenta atrás para ecografías",
      "Planificación de controles de gestación",
      "Árbol genealógico y pedigrí",
      "Desarrollo del potro",
      "Resumen de todas las yeguas gestantes",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Por mes · Módulo de cría incluido en Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Empieza hoy",
      title: "Comienza con la gestión de cría.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Módulo herrador",
    title: "Trabaja de forma más inteligente como herrador. Registra todo de manera profesional.",
    subtitle: "Agenda, fotos, comentarios e historial de tratamientos en un solo módulo — menos malentendidos, expediente más sólido.",
    primaryCTA: {
      label: "Empieza como herrador",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver el Bundle Professional",
      href: "/professional",
    },
    audience: "Para herradores que desean mejorar la organización, la documentación y la comunicación con sus clientes.",
    features: [
      "Agenda propia",
      "Citas por cliente",
      "Ver perfiles de caballos",
      "Añadir fotos de antes y después",
      "Registrar el tratamiento",
      "Anotar consejos y observaciones",
      "Notificación ETA al cliente: \"El herrador está en camino\"",
    ],
    benefits: [
      "Trabajo más profesional",
      "Menos malentendidos",
      "Mejor construcción del expediente",
      "Mayor respaldo ante responsabilidades",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Por mes · Módulo herrador incluido en Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "¿Listo?",
      title: "Activa el Módulo Herrador.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Módulo de odontología",
    title: "Un historial dental completo por caballo.",
    subtitle: "Registra hallazgos, tratamientos y seguimiento directamente en EquiSight.",
    primaryCTA: {
      label: "Comenzar como odontólogo equino",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver Bundle Professional",
      href: "/professional",
    },
    audience: "Odontólogos equinos, veterinarios y clínicas que desean trabajar de forma estructurada.",
    features: [
      "Registrar revisión dental",
      "Hallazgos por tratamiento",
      "Añadir fotografías",
      "Informe al propietario",
      "Consejo de seguimiento",
      "Historial por caballo",
      "Planificar nueva cita",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Por mes · Módulo de odontología incluido en Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "¿Listo?",
      title: "Activa el Módulo de Odontología.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Módulo Fisio / Osteo",
    title: "Haz un seguimiento profesional del cuerpo, el movimiento y la recuperación.",
    subtitle: "Para fisioterapeutas y osteopatas que desean acompañar a los caballos de forma estructurada.",
    primaryCTA: {
      label: "Comenzar como fisio/osteo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver el Paquete Professional",
      href: "/professional",
    },
    features: [
      "Ficha de admisión por caballo",
      "Registrar hallazgos corporales",
      "Añadir fotos y vídeos",
      "Crear informe de tratamiento",
      "Compartir ejercicios y seguimiento",
      "Seguir el proceso de recuperación",
      "Historial por caballo",
    ],
    benefits: [
      "Mejor visión a lo largo del tiempo",
      "Informes profesionales",
      "Comunicación clara con el propietario, el entrenador y el jinete",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Por mes · Módulo Fisio / Osteo incluido en Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "¿Listo?",
      title: "Activa el Módulo Fisio / Osteo.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Módulo de entrenador",
    title: "Entrena a tus jinetes con datos, objetivos y progreso.",
    subtitle: "Haz el entrenamiento medible y la orientación más profesional — para uno o varios jinetes.",
    primaryCTA: {
      label: "Comenzar como entrenador",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver paquete Pro",
      href: "/#pricing",
    },
    audience: "Para instructores, entrenadores y coaches con varios jinetes o caballos.",
    features: [
      "Vincular jinetes",
      "Seguir caballos",
      "Establecer objetivos de entrenamiento",
      "Dar feedback",
      "Analizar resultados de competición",
      "Ver el progreso por combinación",
      "Usar análisis de protocolos para el enfoque del entrenamiento",
    ],
    benefits: [
      "Mejor orientación",
      "Más estructura",
      "Comunicación más profesional",
      "Mayor fidelización con los clientes",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Por mes · Módulo de entrenador incluido en Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "¿Listo?",
      title: "Activa el Módulo de Entrenador.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Análisis de competición",
    title: "Del protocolo a la mejora del rendimiento.",
    subtitle: "Sube tu protocolo de competición y descubre dónde estás perdiendo puntos — no solo consultes tu puntuación, sino entiende cómo mejorar.",
    primaryCTA: {
      label: "Analiza tu primer protocolo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver Premium",
      href: "/premium",
    },
    features: [
      "Subir foto del protocolo",
      "Procesar anverso y reverso",
      "Reconocer clase, número de prueba y juez",
      "Analizar puntuaciones por ejercicio",
      "Resumir comentarios",
      "Mostrar puntos fuertes y débiles",
      "Tendencias por combinación caballo-jinete",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Por mes · análisis de competición incluido desde Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "¿Listo?",
      title: "Empieza con el análisis de competición.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Paquete Professional",
    title: "Para los profesionales del mundo ecuestre.",
    subtitle: "Herrador, dentista, fisio, osteo o entrenador: colabora en un único expediente digital del caballo.",
    primaryCTA: {
      label: "Empieza como profesional",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Ver módulos individuales",
      href: "#features",
    },
    audience: "El Paquete Professional combina todos los módulos especializados en una sola suscripción.",
    features: [
      "Módulo de Herrador",
      "Módulo de Dentista",
      "Módulo de Fisio / Osteo",
      "Agenda y gestión de clientes",
      "Perfiles de caballos e informes",
      "Historial de tratamientos y expedientes",
      "Comunicación con el propietario",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Por mes · todos los módulos especializados incluidos",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "¿Listo?",
      title: "Elige Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Números de emergencia del caballo",
    title: "Siempre la ayuda correcta al alcance de tu mano.",
    subtitle: "En una emergencia, cada segundo cuenta. Con EquiSight tienes todos los datos de contacto importantes de tu caballo disponibles de inmediato — un toque y ya estás llamando.",
    primaryCTA: {
      label: "Prepara tus contactos de emergencia",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Empieza gratis con EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Contactos de emergencia — llama, envía WhatsApp o navega directamente al veterinario, clínica y herrador",
      caption: "Un toque. Sin pánico ni búsquedas.",
      embeddedFrame: true,
    },
    problem: "Tu caballo tiene algo — cólico, lesión, pánico. Y entonces empieza la búsqueda. ¿A quién llamas? ¿Tienes el número correcto? ¿Es este el número de urgencias? Se pierde un tiempo valioso.",
    solution: "Con EquiSight lo tienes todo a mano de inmediato. Sin búsquedas. Sin dudas. Un toque y tienes contacto.",
    scenario: {
      title: "Imagínate — tu caballo muestra síntomas de cólico.",
      steps: [
        "Abres EquiSight",
        "Tocas \"Veterinario\"",
        "Llamas directamente",
      ],
      tagline: "Sin estrés. Sin búsquedas. Solo acción.",
    },
    features: [
      "Todos los números de emergencia en un solo lugar",
      "Llamadas con un toque desde la app",
      "WhatsApp con un solo toque",
      "Navega directamente a la dirección",
      "Lista de contactos propia por caballo",
      "Veterinario, clínica, herrador, dentista, fisio",
      "Dirección y cómo llegar disponibles de inmediato",
      "Marca tus números favoritos con una estrella",
      "Números de urgencias (112, 144) siempre arriba",
    ],
    benefits: [
      "Calma y control en una situación de emergencia",
      "Todo el personal del establo tiene los mismos números a mano",
      "Se acabaron las tarjetas de visita olvidadas",
      "Reacciona segundos más rápido en urgencias",
    ],
    audience: "Para propietarios de caballos, cuidadores, entrenadores y establos — todos los que son responsables de un caballo.",
    showcase: {
      eyebrow: "Configurado de antemano para ti",
      title: "13 categorías de contactos — listas para rellenar.",
      description: "Desde el veterinario y la clínica de urgencias hasta el talabartero, el instructor y el gestor de pastos. EquiSight conoce tu mundo y prepara los campos de contacto correctos para ti. Toca, rellena, listo.",
      bullets: [
        "Urgencias y salud — veterinario, urgencias, clínica, línea de intoxicaciones",
        "Cuidado diario — herrador, dentista, fisio, instructor",
        "Establo y pastos — propietario del establo, gestor de pastos, pensión ecuestre",
        "Pienso y materiales — proveedores de heno, pienso concentrado y paja",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Pantalla de gestión de contactos de emergencia — todos los contactos sugeridos por categoría",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Lista de verificación de números de emergencia del caballo",
      items: [
        "Veterinario",
        "Clínica de urgencias (24/7)",
        "Ambulancia veterinaria · 144",
        "Herrador",
        "Contacto de reserva",
        "Número de emergencias general · 112",
      ],
      cta: {
        label: "Ábrelo en EquiSight y rellénalo de inmediato",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Números de emergencia",
          price: "Gratis",
          note: "Siempre gratis · para todos, en cualquier plan",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Asegúrate de estar preparado",
      title: "Antes de que sea necesario.",
      href: "/#waitlist",
    },
    microcopy: [
      "Sin compromisos",
      "Configurado en menos de 2 minutos",
      "Siempre personalizable",
    ],
  },
};

export default LANDINGS;
